module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "platinum.92ba0ecd.png";